module.exports = __webpack_public_path__ + "static/media/16.1714e9d1.mp3";